import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NutshellToOffice365 from './icon-nutshell-to-office-365.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    if (validProps.width && validProps.height) {
        delete validProps.height;
    }

    return <NutshellToOffice365 {...validProps} />;
}
SvgComponent.iconName = 'nutshellToOffice365';

export const NutshellToOffice365Icon = svgIconWrapper(SvgComponent);
